import { Button, ButtonProps, styled } from '@mui/material'
import React from 'react'

const StandardButton: React.FC<ButtonProps> = ({ ...buttonProps }) => {
    return (
        <ResponsiveButton disableElevation {...buttonProps} />
    )
}

const ResponsiveButton = styled(Button)(({ theme }) => ({
    [theme.breakpoints.down("sm")]: {
        flex: 1,
        fontSize: "16px",
        borderRadius: "12px",
        "& .MuiButton-startIcon, .MuiButton-endIcon": {
            width: "24px",
            height: "24px",
        },
    },
}));

export default StandardButton
